module.exports = __webpack_public_path__ + "static/media/playback-rate-icon.091a6bee.svg";